// @flow

import Service from './service';
import type { HttpResponseType } from '../types/http-response';
import type { TotalDeductionSummaryType } from '../types/tax';

export default class TaxUserService extends Service {
  getTaxUser(): Promise<boolean> {
    return this.api.get(`${this.baseUrl}/user/tax-user`)
      .then((res: HttpResponseType) => (res.status === 200))
      .catch(() => false);
  }

  taxReportExport(year: number, email: string): Promise<string> {
    const params = {
      year,
      email,
    };
    return this.api.post(`${this.baseUrl}/user/tax-user/tax-report`, params)
      .then((res: HttpResponseType) => res.data);
  }

  getDeductionSummary(year: number): Promise<TotalDeductionSummaryType> {
    return this.api.get(`${this.baseUrl}/user/tax-user/deductions?year=${year}`)
      .then((res: HttpResponseType) => res.data);
  }
}
